import { createServiceURL } from 'shared/utils'

const templatesModule = 'layout_designer_templates'
const getTemplatesEndpoint = 'templates'

export const templatesEndpoint = createServiceURL(
  templatesModule,
  getTemplatesEndpoint
)
